import React from 'react';
import Navbar from '../components/Navbar';
import HeroImage from '../components/HeroImage';
import Footer from '../components/Footer';
import TrainingCom from '../components/TrainingCom';
const Training = () => {
    return (
        <>
        <Navbar/>
        <HeroImage titel="Training" text='Pre-flight and In-Flight Training.'/>
        <TrainingCom/>
        <Footer/>    
        </>
    );
}

export default Training;
